import React, { useState, createContext } from 'react';

export const HeaderContext = createContext();

export const HeaderProvider = (props) => {
	const [headerContent, setHeaderContent] = useState(<p>SportWise</p>);
	return <HeaderContext.Provider value={[headerContent, setHeaderContent]}>{props.children}</HeaderContext.Provider>;
};
